import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { textSx } from './filterStyles';

/**
 * Campo de busca dos filtros do Admin Geral > Novidades.
 * @param {{ value: string, onChange: Function, placeholder: string }} props
 */
function SearchField({ value, onChange, placeholder }) {
  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'text.disabled', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
      sx={{ flex: 1, minWidth: 220, maxWidth: { sm: 340 }, ...textSx }}
    />
  );
}

export default SearchField;
